<template>
  <section class="step1-form step2_bl"  :style="{minHeight:(screenHeight-85)+'px'}">
    <div v-if="this.$route.query.yanse == 1"  class="step-form__step-num2" >1/5</div>
    <div v-if="this.$route.query.yanse == 2" class="step-form__step-num" >1/5</div>
    <!--<div v-if="Number(userInfo.crmCustomerType) === 1">-->
    <div>
      <div class="step-form__main">
        <h1 class="step-form__title">{{this.$route.query.productName}}-填写融资基本信息</h1>
        <el-row :gutter="0">
          <el-button @click="addTable" style="margin-left: 10px;margin-top: 90px;" v-if="!this.$route.query.productName.includes('交')" v-show="this.$route.query.yanse == 1">+</el-button>
          <el-button @click="importData" style="margin-left: 20px;margin-top: 110px;" v-if="!this.$route.query.productName.includes('交')" v-show="this.$route.query.yanse == 1">导入</el-button>
          <el-button @click="addTable" style="margin-left: 10px;margin-top: 190px;" v-if="this.$route.query.productName.includes('交')" v-show="this.$route.query.yanse == 1">+</el-button>
          <el-button @click="importData" style="margin-left: 20px;margin-top: 210px;" v-if="this.$route.query.productName.includes('交')" v-show="this.$route.query.yanse == 1">导入</el-button>          
          <el-col :span="16">
            <el-form class="step-form__form" :label-width="'50%'" :model="step2Form" :rules="rules" ref="step2Form">
            <el-form-item label="买方"
                          prop="buyerId" v-show="this.$route.query.yanse == 1">
              <el-select v-model="step2Form.buyerId"
                         placeholder="请选择买方"
                         class="buyerName">
                <el-option :label="item.buyerName"
                           :value="item.buyerId"
                           v-for="(item,index) in partnerList"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>    
            <el-form-item label="贸易基础交易合同起止日" v-if="this.$route.query.productName.includes('交')">
                <!-- <el-date-picker
                  v-model="step2Form.businessContractDate"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  >
                </el-date-picker> -->
                <el-date-picker type="date" 
                  v-model="step2Form.businessContractStartDate"
                  value-format="yyyy-MM-dd" style="width:47%"></el-date-picker>至
                <el-date-picker type="date"
                  v-model="step2Form.businessContractEndDate"
                  value-format="yyyy-MM-dd" style="width:47%"></el-date-picker>
            </el-form-item>
            <el-form-item label="交易标的品种" v-if="this.$route.query.productName.includes('交')">
              <el-input type="tel" placeholder="请输入交易标的品种"
                          v-model="step2Form.scmBusinessType"></el-input>
            </el-form-item>
            <el-form-item>
            <el-table :data="tableDatas" v-if="this.$route.query.yanse == 1"  border show-summary sum-text="发票总金额" :summary-method="getSummaries">
                  <el-table-column label="发票编码" align="center">
                      <template slot-scope="scope">
                          <el-input placeholder="先输入发票号后输入金额"  v-model="scope.row.code" :input="setAmountValue(scope.row.code,scope.$index)"></el-input>
                      </template>
                  </el-table-column>
                  <el-table-column label="发票金额（元）" prop="amount" align="center">
                      <template slot-scope="scope">
                          <el-input type="number" text-align="center" v-model="scope.row.amount" :disabled="scope.row.code == ''"></el-input>
                      </template>
                  </el-table-column>
              </el-table>      
              </el-form-item>                  
              <!-- <el-form-item label="发票号码" prop="bizNos" v-show="this.$route.query.yanse == 1">
                <el-input type="textarea" :rows="4" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请输入发票号码，多个以','分隔"
                        style="padding-bottom:15px;"  v-model="step2Form.bizNos">
                </el-input>
              </el-form-item>  -->
              <!-- <el-form-item label="发票总金额" prop="bizAmountSum" v-show="this.$route.query.yanse == 1">
                <el-input type="text " placeholder="请输入发票总金额"
                          v-model="step2Form.bizAmountSum"></el-input>
              </el-form-item> -->
              <el-form-item label="经办人" prop="agent">
                <el-input type="tel" placeholder="请输入经办人名字"
                          v-model="step2Form.agent"></el-input>
              </el-form-item>
              <el-form-item label="经办人身份证" prop="agentIdNo">
                <el-input type="tel" placeholder="请输入经办人身份证号码" :maxlength="18"
                          v-model="step2Form.agentIdNo"></el-input>
              </el-form-item>
              <el-form-item label="经办人电话" prop="agentContact">
                <el-input type="tel" placeholder="请输入经办人电话" :maxlength="11"
                          v-model="step2Form.agentContact"></el-input>
              </el-form-item>
              <el-form-item label="其他说明" prop="ortherRemark">
                <el-input type="textarea" placeholder="" :rows="5"
                          v-model="step2Form.ortherRemark"></el-input>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div class="step-form__btn-container">
          <button v-if="this.$route.query.yanse == 1" class="step-form__btn-next2"  @click="submitForm('step2Form')">下一步</button>
          <button v-if="this.$route.query.yanse == 2" class="step-form__btn-next"  @click="submitForm('step2Form')">下一步</button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogTicketInfo" :show-close="true" top="70px">
      <div v-html="contractText"></div>
    </el-dialog>
    <el-dialog class="fail-modal" top="23%" :visible="gylFailModal.show" :before-close="beforeCloseGylFileModal"
               :close-on-click-modal="false">
      <div class="fail-modal__text">{{gylFailModal.content}}</div>
    </el-dialog>    
 <!-- 批量导入Excel -->
 <el-dialog title="导入发票号" :visible.sync="dialogImportVisibleExcel" :modal-append-to-body="false" :close-on-click-modal="false" class="dialog-import">
    <div :class="{'import-content': importFlag === 1, 'hide-dialog': importFlag !== 1}">
        <el-upload class="upload-demo"
          :action="importUrl"
          :name ="name"
          :data="excelData"
          :headers="importHeaders"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-upload="beforeUploadImportExcel"
          :on-error="uploadFailImport"
          :on-success="uploadSuccessImport"
          :file-list="fileList"
          :with-credentials="withCredentials">
           <el-button size="small" type="primary" :disabled="processing">{{uploadTip}}</el-button>
           <el-button size="small" type="primary" @click="downTemplate" round>下载模板</el-button>
           <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload>
        </div>
 </el-dialog>
  </section>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';
  import * as types from '../../vuex/types';
  import _ from 'lodash';
  import axios from 'axios';
  import applyloanApi from '../../api/applyloan'; // 引入企业证件API
  import ElButton from '../../../node_modules/element-ui/packages/button/src/button';
  import ElDialog from '../../../node_modules/element-ui/packages/dialog/src/component';
  import billApi from '../../api/myBill.js';

  // 企业那边如果界面差异变大，则建议分出去另一个组件
  export default {
    components: {
      ElDialog,
      ElButton},
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
//        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options});
        }
      });
      return {
        gylFailModal:{
          show:false,
          content:''
        },        
        importUrl: '',
        importHeaders: {
          enctype: 'multipart/form-data'
        },
        excelData: {},
        name: 'file',
        fileList: [],
        withCredentials: true,
        processing: false,
        uploadTip: '点击上传',
        importFlag: 1,
        dialogImportVisibleExcel: false,
        partnerList: [], // 买方信息列表
        yanse: '',
        fullscreenLoading: false,
        frontApplyId: 0,
        loanProductDetail: '',
        FrontApplyInfo: '',
        dialogTicketInfo: false,
        contractText: '',
        isSubmitting: false,
        isEditable: '',
        screenHeight: document.body.clientHeight,
        tableDatas:[{code:'',amount:''}],
        tableDatasSubmit:[],
        step2Form: {
          buyerId:'',//买方id
          bizAmountSum: '', // 发票总金额
          bizNos: '', // 发票号码s
          forecastReceAmount: '',
          expectTransferAmount: '',
          agent: '',
          agentIdNo: '',
          agentContact: '',
          ortherRemark: '',
          // hasReadContract: false
          hasReadContract: true,
          businessContractDate:'',
          businessContractStartDate:'',
          businessContractEndDate:'',
          scmBusinessType:''
        },
        rules: {
          forecastReceAmount: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入预估应收账款余额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('预估应收账款余额必须为数字'));
              } else if (value > this.loanProductDetail.productMaxLimit) {
                callback(new Error(`预估应收账款余额不可以大于${this.loanProductDetail.productMaxLimit}元`));
              } else if (value < this.loanProductDetail.productMinLimit) {
                callback(new Error(`预估应收账款余额不可以小于${this.loanProductDetail.productMinLimit}元`));
              } else {
                callback();
              }
            }
          }],
          expectTransferAmount: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入预转让金额'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('预转让金额必须为数字'));
              } else if (value > this.loanProductDetail.productMaxLimit) {
                callback(new Error(`预转让金额不可以大于${this.loanProductDetail.productMaxLimit}元`));
              } else if (value < this.loanProductDetail.productMinLimit) {
                callback(new Error(`预转让金额不可以小于${this.loanProductDetail.productMinLimit}元`));
              } else if (Number(value) > Number(this.step2Form.forecastReceAmount)) {
                callback(new Error(`预转让金额不可以大于预估应收账款余额`));
              } else {
                callback();
              }
            }
          }],
          agent: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (value.toString().trim() === '') {
                callback(new Error('请输入经办人名称'));
              } else if (!(/^[\u4E00-\u9FFF]+$/.test(value))) {
                callback(new Error('姓名必须为中文字符'));
              } else {
                callback();
              }
            }
          }],
          bizNos: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (this.$route.query.yanse == 1) {
                if (value.toString().trim() === '') {
                  callback(new Error("请输入发票号码，多个以','分隔"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }],
          buyerId: [{ type: 'number',
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (this.$route.query.yanse == 1) {
                if (value.toString().trim() === '') {
                  callback(new Error("请选择买方"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }             
          }],          
          bizAmountSum: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (this.$route.query.yanse == 1) {
                if (value.toString().trim() === '') {
                  callback(new Error('请输入发票总金额'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            }
          }],
          agentIdNo: [{
            trigger: 'blur',
            required: false,
            validator: (rules, value, callback) => {
              if (value != undefined &&  value != '' && value.length !== 18) {
                callback(new Error('必须为18位身份证号'));
              } else if (value != undefined &&  value != '' && !this.isCardID(value)) {
                callback(new Error('身份证号码格式错误'));
              } else {
                callback();
              }
            }
          }],
          agentContact: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value == undefined || value == '') {
                callback(new Error('请输入经办人电话'));
              } else if (value.length !== 11) {
                callback(new Error('必须为11位手机号码'));
              } else {
                callback();
              }
            }
          }],
//          realName: [assignValidator((types.VERIFY_CHN_NAME))],
//          IDCardNum: [assignValidator(types.VERIFY_ID_CARD_NUM)],
//          cellphone: [assignValidator(types.VERIFY_CELLPHONE)],
          customerName: [{
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('客户名称不能为空'));
              } else {
                callback();
              }
            }
          }],
          enterpriseNumber: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('营业执照号不能为空'));
              } else {
                callback();
              }
            }
          }],
          enterpriseOrganizingNumber: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('证件号码不能为空'));
              } else {
                callback();
              }
            }
          }],
          userType: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }],
          registrationType: [{
            require: true,
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }],
          enterpriseLegalUser: [assignValidator((types.VERIFY_CHN_NAME))],
          enterpriseLegalUserPhone: [assignValidator(types.VERIFY_CELLPHONE)],
          enterpriseLegalIdNo: [assignValidator(types.VERIFY_ID_CARD_NUM)]
        },
        step2FormEnterprise: {
          customerName: '',
          enterpriseNumber: '',
          enterprisePartnerNumber: '',
          enterpriseRegAddr: '',
          enterpriseType: '',
          enterpriseRegMoney: '',
          enterpriseLegalUser: '',
          enterpriseLegalIdNo: '',
          enterpriseLegalUserPhone: '',
          enterpriseOrganizingNumber: '',
          enterpriseScale: '',
          enterpriseNationalNumber: '',
          enterpriseGovernmentNumber: '',
          enterpriseRegOrgan: '',
          enterpriseEmployeeNum: '',
          enterpriseScope: '',
          enterpriseFoundExplain: '',
          enterpriseScaleArray: [],
          enterpriseTypeArray: [],
          userType: 1,
          registrationType: 0
        }
      };
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        myInfo: types.GET_MY_INFO,
        userInfo: types.GET_USER
      })
    },
    methods: {
    // 导入功能开始----------------------------------------
    importData () {
      this.dialogImportVisibleExcel = true;
      this.importUrl = `${this.ajaxBaseUrl}/loanform/blitem/blLoanAccountVoucherInfo/supplyChainInvoiceNoImport.ht`;
      this.excelData = {
        tokenId: localStorage.getItem('dl_tokenId_bl')
      };
        this.importFlag = 1;
        this.fileList = [];
        this.uploadTip = '点击上传';
        this.processing = false;
     },      
      handlePreview (file) {
        // 可以通过 file.response 拿到服务端返回数据
      },
      handleRemove (file, fileList) {
        // 文件移除
      }, 
       beforeUploadImportExcel (file) {
        // 上传前配置
          const excelfileExtend = '.xls,.xlsx';// 设置文件格式
          const fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
          if (excelfileExtend.indexOf(fileExtend) <= -1) {
          this.setFailMessage({
            show: true,
            content: '文件格式错误'
          });
             return false;
          }
          this.uploadTip = '正在处理中...';
          this.processing = true;
       },  
      // 上传错误
     uploadFailImport (err, file, fileList) {
        this.uploadTip = '点击上传';
        this.processing = false;
        this.setFailMessage({
        show: true,
        content: err
      });
     },   
      // 上传成功
     uploadSuccessImport (response, file, fileList) {
        this.uploadTip = '点击上传';
        this.processing = false;
        if (response.code === 0) {
          this.importFlag = 3;
          this.dialogImportVisibleExcel = false;
          this.step2Form.bizNos = response.result.invoiceNos;
          this.tableDatas = JSON.parse(response.result.invoiceNos);
          this.step2Form.bizAmountSum = response.result.amount;
          this.setSuccessMessage({
          show: true,
          content: '导入成功'
        });
        } else {
          this.setFailMessage({
            show: true,
            content: response.msg
          });
        };
        this.fileList = [];
     },                
      inputBlurFn (prop) {
        if (event.srcElement) {
          this.step1Form[prop] = event.srcElement.value;
        }
      },
      ...mapActions({
        updatePassword: types.UPDATE_PASSWORD,
        getPersonalInfo: types.GET_PERSONAL_INFO,
        getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
        savePersonalInfo: types.SAVE_PERSONAL_INFO,
        saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
        saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      isCardID (sId) {
		  const aCity = {11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外'};
		  let iSum = 0;
		  const info = '';
		  if (!/^\d{17}(\d|x)$/i.test(sId)) return false;// "你输入的身份证长度或格式错误";
		  sId = sId.replace(/x$/i, 'a');
		  if (aCity[parseInt(sId.substr(0, 2))] == null) return false;// "你的身份证地区非法";
		  const sBirthday = `${sId.substr(6, 4)}-${Number(sId.substr(10, 2))}-${Number(sId.substr(12, 2))}`;
		  const d = new Date(sBirthday.replace(/-/g, '/'));
		  if (sBirthday != (`${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`)) return false;// "身份证上的出生日期非法";
		  for (let i = 17; i >= 0; i--) iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
		  if (iSum % 11 != 1) return false;// "你输入的身份证号非法";
		  return true;
      },

      goBack () {
        const productId = this.$route.params.id;
        this.$router.push({
          name: 'factoring',
          query: {...this.$route.query, productId}
        });
      },
      /**
       * 根据路由参数产品id查询草稿项目
       */
      getDraftApply () {
        const frontApplyId = this.$route.query.frontApplyId;
        const baseProductId = this.$route.params.id;
        applyloanApi.getDraftApply(baseProductId,frontApplyId).then((res) => {
          if (Number(res.data.code) === 0) {
            if (!res.data.result) {
              return;
            }
            this.step2Form = Object.assign(this.step2Form, res.data.result);
            this.step2Form.ortherRemark = this.step2Form.remark;
            this.frontApplyId = res.data.result.frontApplyId;
            this.tableDatas = JSON.parse(res.data.result.bizNos);
          } else {
            this.setFailMessage({
              show: true,
              content: res.msg || '数据获取失败'
            });
          }
        }).catch((error) => {
          console.error(error);
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
      },
      dateChange(e, type) {
        if (e) {
          const date = e
            .replace(/(\s*)/g, "")
            .replace(/年/, "-")
            .replace(/月/, "-")
            .replace(/日/, "");
         this.step2Form.businessContractDate = date;
        }
      },      
      /**
       * 提交表单
       */
      submitForm (formName) {

        if(this.$route.query.yanse == 1){//供应链业务校验发票信息是否填写
          this.tableDatas.forEach((data) => {
            if(data.amount != ''){
              this.tableDatasSubmit.push(data);
            }
          });
          if(this.tableDatasSubmit.length == 0){
            this.setFailMessage({
                  show: true,
                  content: '请填写发票信息'
                });
            return;
          }else{
            this.step2Form.bizNos = JSON.stringify(this.tableDatasSubmit);
          }
        }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.step2Form.hasReadContract) {
              if(this.$route.query.yanse == 1){//供应链业务校验发票信息是否填写
              if(this.step2Form.businessContractDate[0]!=null){
                const year = this.step2Form.businessContractDate[0].getFullYear();
                const month = ('0' + (this.step2Form.businessContractDate[0].getMonth() + 1)).slice(-2);
                const day = ('0' + this.step2Form.businessContractDate[0].getDate()).slice(-2);
                this.step2Form.businessContractDate[0] = `${year}-${month}-${day}`;
              }
              if(this.step2Form.businessContractDate[1]!=null){
                const year = this.step2Form.businessContractDate[1].getFullYear();
                const month = ('0' + (this.step2Form.businessContractDate[1].getMonth() + 1)).slice(-2);
                const day = ('0' + this.step2Form.businessContractDate[1].getDate()).slice(-2);
                this.step2Form.businessContractDate[1] = `${year}-${month}-${day}`;
              }
              
                applyloanApi.checkMainContractSign(this.step2Form.buyerId,this.$route.params.id)
                .then((res) => {
                  if(res.data.code == 0){
                      this.fullscreenLoading = true;
                      applyloanApi.inputFinancingDemandInfo({
                        tokenId: localStorage.getItem('dl_tokenId_bl'),
                        productId: this.$route.params.id,
                        forecastReceAmount: 0,
                        expectTransferAmount: 0,
                        agent: this.step2Form.agent,
                        agentIdNo: this.step2Form.agentIdNo,
                        agentContact: this.step2Form.agentContact,
                        ortherRemark: this.step2Form.ortherRemark || '',
                        frontApplyId: this.frontApplyId,
                        bizAmountSum: this.step2Form.bizAmountSum || '',
                        bizNos: this.step2Form.bizNos || '',
                        buyerId: this.step2Form.buyerId || '',
                        businessContractStartDate:this.step2Form.businessContractDate[0],
                        businessContractEndDate:this.step2Form.businessContractDate[1],
                        scmBusinessType:this.step2Form.scmBusinessType || ''
                      }).then((res) => {
                        this.fullscreenLoading = false;
                        if (res.rspcode === 1) {
                          this.frontApplyId = res.data.frontApplyId;
                          this.$router.push({
                            path: `/applyLoan/${this.$route.params.id}/step3_bak_bl`,
                            query: {
                              frontApplyId: res.data.frontApplyId,
                              yanse: this.$route.query.yanse,
                              productName: this.$route.query.productName
                            }
                          });
                        } else {
                          this.setFailMessage({
                            show: true,
                            content: res.rspdesc || '数据获取失败'
                          });
                        }
                      }).catch((error) => {
                        this.fullscreenLoading = false;
                        this.setFailMessage({
                          show: true,
                          content: '网络异常，请稍后再试'
                        });
                      });
                  }else{
                    this.gylFailModal.show = true;
                    this.gylFailModal.content = res.data.msg;
                  }
                });
              }else{
                this.fullscreenLoading = true;
                applyloanApi.inputFinancingDemandInfo({
                  tokenId: localStorage.getItem('dl_tokenId_bl'),
                  productId: this.$route.params.id,
                  forecastReceAmount: 0,
                  expectTransferAmount: 0,
                  agent: this.step2Form.agent,
                  agentIdNo: this.step2Form.agentIdNo,
                  agentContact: this.step2Form.agentContact,
                  ortherRemark: this.step2Form.ortherRemark || '',
                  frontApplyId: this.frontApplyId,
                  bizAmountSum: this.step2Form.bizAmountSum || '',
                  bizNos: this.step2Form.bizNos || '',
                  buyerId: this.step2Form.buyerId || ''
                }).then((res) => {
                  this.fullscreenLoading = false;
                  if (res.rspcode === 1) {
                    this.frontApplyId = res.data.frontApplyId;
                    this.$router.push({
                      path: `/applyLoan/${this.$route.params.id}/step3_bak_bl`,
                      query: {
                        frontApplyId: res.data.frontApplyId,
                        yanse: this.$route.query.yanse,
                        productName: this.$route.query.productName
                      }
                    });
                  } else {
                    this.setFailMessage({
                      show: true,
                      content: res.rspdesc || '数据获取失败'
                    });
                  }
                }).catch((error) => {
                  this.fullscreenLoading = false;
                  this.setFailMessage({
                    show: true,
                    content: '网络异常，请稍后再试'
                  });
                });
              }

            } else {
              this.setFailMessage({
                show: true,
                content: '请先阅读并同意贷款协议'
              });
            }
          } else {
            return false;
          }
        });

        // 第一步为添加，第二步开始，保存后调用更新项目进度接口
//        this.$refs.step2Form.validate((valid) => {
//          if (valid) {
//            this.isSubmitting = true
//            if (this.userInfo.crmCustomerType === '1') {
//              // 个人
//              this.saveApplyLoanProgress({
//                router: this.$router,
//                token: this.userInfo.token,
//                id: this.$route.query.applyLoanId,
//                step: 2
//              }).then((res) => {
//                const resData = res.data
//                if (Number(resData.code) === 0) {
//                  this.isSubmitting = false
//                  this.$router.push({
//                    path: `/applyLoan/${this.$route.params.id}/step3`,
//                    query: {
//                      applyLoanId: this.$route.query.applyLoanId,
//                      isEdit: this.$route.query.isEdit
//                    }
//                  })
//                }
//              })
//              // this.savePersonalInfo({
//              //   router: this.$router,
//              //   token: this.userInfo.token,
//              //   customerId: this.userInfo.crmCustomerId,
//              //   customerName: this.step2Form.realName,
//              //   personIdentityCard: this.step2Form.IDCardNum,
//              //   personMobile: this.step2Form.cellphone
//              // }).then((saveRes) => {
//              //   if (Number(saveRes.data.code) === 0) {
//              //     this.saveApplyLoanProgress({
//              //       router: this.$router,
//              //       token: this.userInfo.token,
//              //       id: this.$route.query.applyLoanId,
//              //       step: 2
//              //     }).then((res) => {
//              //       const resData = res.data
//              //       if (Number(resData.code) === 0) {
//              //         this.isSubmitting = false
//              //         this.$router.push({
//              //           path: `/applyLoan/${this.$route.params.id}/step3`,
//              //           query: {
//              //             applyLoanId: this.$route.query.applyLoanId,
//              //             isEdit: this.$route.query.isEdit
//              //           }
//              //         })
//              //       }
//              //     })
//              //   }
//              // })
//            } else {
//              // 企业
//              this.saveEnterpriseInfo({
//                router: this.$router,
//                token: this.userInfo.token,
//                customerId: this.userInfo.crmCustomerId,
//                customerName: this.step2FormEnterprise.customerName,
//                enterpriseNumber: this.step2FormEnterprise.enterpriseNumber,
//                enterprisePartnerNumber: this.step2FormEnterprise.enterprisePartnerNumber,
//                enterpriseRegAddr: this.step2FormEnterprise.enterpriseRegAddr,
//                enterpriseType: this.step2FormEnterprise.enterpriseType,
//                enterpriseRegMoney: this.step2FormEnterprise.enterpriseRegMoney,
//                enterpriseLegalUser: this.step2FormEnterprise.enterpriseLegalUser,
//                enterpriseLegalIdNo: this.step2FormEnterprise.enterpriseLegalIdNo,
//                enterpriseLegalUserPhone: this.step2FormEnterprise.enterpriseLegalUserPhone,
//                enterpriseOrganizingNumber: this.step2FormEnterprise.enterpriseOrganizingNumber,
//                enterpriseScale: this.step2FormEnterprise.enterpriseScale,
//                enterpriseNationalNumber: this.step2FormEnterprise.enterpriseNationalNumber,
//                enterpriseGovernmentNumber: this.step2FormEnterprise.enterpriseGovernmentNumber,
//                enterpriseRegOrgan: this.step2FormEnterprise.enterpriseRegOrgan,
//                enterpriseEmployeeNum: this.step2FormEnterprise.enterpriseEmployeeNum,
//                enterpriseScope: this.step2FormEnterprise.enterpriseScope,
//                enterpriseFoundExplain: this.step2FormEnterprise.enterpriseFoundExplain,
//                userType: this.step2FormEnterprise.userType,
//                registrationType: this.step2FormEnterprise.registrationType
//              }).then((saveRes) => {
//                if (Number(saveRes.data.code) === 0) {
//                  this.saveApplyLoanProgress({
//                    router: this.$router,
//                    token: this.userInfo.token,
//                    id: this.$route.query.applyLoanId,
//                    step: 2
//                  }).then((res) => {
//                    const resData = res.data
//                    if (Number(resData.code) === 0) {
//                      this.isSubmitting = false
//                      this.$router.push({
//                        path: `/applyLoan/${this.$route.params.id}/step3`,
//                        query: {
//                          applyLoanId: this.$route.query.applyLoanId,
//                          isEdit: this.$route.query.isEdit
//                        }
//                      })
//                    }
//                  })
//                }
//              })
//            }
//          } else {
//            return false
//          }
//        })
      },
//      贷款协议
      showLoanContract () {
        applyloanApi.getContentText({
          contentMinTitle: 'rzxy',
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }).then((res) => {
          if (res.rspcode === 1) {
            this.contractText = res.data.contentText;
            this.dialogTicketInfo = true;
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {
          console.error(error);
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
      },

//      获取产品详情
      getLoanProductDetail () {
        applyloanApi.getLoanProductDetail({
          productId: this.$route.params.id
        }).then((res) => {
          if (res.code == 0) {
            this.loanProductDetail = res.data;
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {
          console.error(error);
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
      },
//      获取项目信息接口
      getFrontApplyInfo (param) {
        applyloanApi.getFrontApplyInfo(param).then((res) => {
          if (res.rspcode == 1) {
            this.step2Form = Object.assign(this.step2Form, res.data);
            this.step2Form.ortherRemark = this.step2Form.remark;
          } else {
            this.setFailMessage({
              show: true,
              content: res.rspdesc || '数据获取失败'
            });
          }
        }).catch((error) => {
          this.setFailMessage({
            show: true,
            content: '网络异常，请稍后再试'
          });
        });
      },
      // 初始化买方数据
      buyerNameData () {
        billApi.addFrontVoucherInfoPage({
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          frontApplyId: 0
        }).then((res) => {
          if (res.rspcode == 1) {
            this.partnerList = res.data;
          }
        }).catch((error) => {});
      },
      // 下载模板
      downTemplate () {
        let url = window.location.href;
        if (url.indexOf('#') != -1) {
          url = url.split('#')[0];
        }
        const elink = document.createElement('a');
        elink.style.display = 'none';
        elink.target = '_blank';
        elink.href = `${url}api/loanform/blitem/blLoanItemFrontApply/downloadExcelTemplate.ht`;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
      },
      //增加发票号列表一行
      addTable(){
        this.tableDatas.push({code:'',amount:''});
      },
      //当发票号无内容清空对应的发票金额输入框内容
      setAmountValue(value,index){
        if(value == ''){
          this.tableDatas[index].amount = '';
        }
      },   
      //合计  
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '发票总金额';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          sums[index] = 0;
          values.forEach((data) => {
            sums[index] = sums[index] + Number(data);
          });
          this.step2Form.bizAmountSum = sums[index];
          sums[index] = sums[index].toFixed(2);
        });
        return sums;
      },
      beforeCloseGylFileModal(){
        this.gylFailModal.show = false;
      }           
    },
    mounted () {
      this.buyerNameData();
      //获取产品详情接口，获取预估预转最大最小值用于校验
      this.$store.commit('changeActive', 1);
      this.getLoanProductDetail();
      this.getDraftApply();
      if (this.userInfo.crmCustomerType === '1') {
        // 个人
        this.getPersonalInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            const data = res.data.data;
            this.isEditable = Number(data.isEditable);
            this.step2Form.agent = data.customerName;
            this.step2Form.agentIdNo = data.personIdentityCard;
            this.step2Form.agentContact = data.mobile;
//            this.step2Form = {
//              realName: (data.customerName != null ? data.customerName : ''),
//              IDCardNum: data.personIdentityCard,
//              cellphone: data.mobile
//            }
          }
        });
      } else {
        // 企业
        this.getEnterpriseInfo({
          router: this.$router,
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            const data = res.data;
            this.isEditable = Number(data.isEditable);
            this.step2Form.agent = data.agent;
            this.step2Form.agentIdNo = data.agentIdNo;
            this.step2Form.agentContact = data.agentContact;
            this.step2FormEnterprise = {
              customerName: (data.customerName != null ? data.customerName : ''),
              enterpriseNumber: (data.crmCustomerEnterprise.enterpriseNumber != null ? data.crmCustomerEnterprise.enterpriseNumber : ''),
              enterprisePartnerNumber: (data.crmCustomerEnterprise.enterprisePartnerNumber != null ? data.crmCustomerEnterprise.enterprisePartnerNumber : ''),
              enterpriseRegAddr: (data.crmCustomerEnterprise.enterpriseRegAddr != null ? data.crmCustomerEnterprise.enterpriseRegAddr : ''),
              enterpriseType: (data.crmCustomerEnterprise.enterpriseType != null ? data.crmCustomerEnterprise.enterpriseType : ''),
              enterpriseRegMoney: (data.crmCustomerEnterprise.enterpriseRegMoney != null ? data.crmCustomerEnterprise.enterpriseRegMoney : ''),
              enterpriseLegalUser: (data.crmCustomerEnterprise.enterpriseLegalUser != null ? data.crmCustomerEnterprise.enterpriseLegalUser : ''),
              enterpriseLegalIdNo: (data.crmCustomerEnterprise.enterpriseLegalIdNo != null ? data.crmCustomerEnterprise.enterpriseLegalIdNo : ''),
              enterpriseLegalUserPhone: (data.crmCustomerEnterprise.enterpriseLegalUserPhone != null ? data.crmCustomerEnterprise.enterpriseLegalUserPhone : ''),
              enterpriseOrganizingNumber: (data.crmCustomerEnterprise.enterpriseOrganizingNumber != null ? data.crmCustomerEnterprise.enterpriseOrganizingNumber : ''),
              enterpriseScale: (data.crmCustomerEnterprise.enterpriseScale != null ? data.crmCustomerEnterprise.enterpriseScale : ''),
              enterpriseNationalNumber: (data.crmCustomerEnterprise.enterpriseNationalNumber != null ? data.crmCustomerEnterprise.enterpriseNationalNumber : ''),
              enterpriseGovernmentNumber: (data.crmCustomerEnterprise.enterpriseGovernmentNumber != null ? data.crmCustomerEnterprise.enterpriseGovernmentNumber : ''),
              enterpriseRegOrgan: (data.crmCustomerEnterprise.enterpriseRegOrgan != null ? data.crmCustomerEnterprise.enterpriseRegOrgan : ''),
              enterpriseEmployeeNum: (data.crmCustomerEnterprise.enterpriseEmployeeNum != null ? data.crmCustomerEnterprise.enterpriseEmployeeNum : ''),
              enterpriseScope: (data.crmCustomerEnterprise.enterpriseScope != null ? data.crmCustomerEnterprise.enterpriseScope : ''),
              enterpriseFoundExplain: (data.crmCustomerEnterprise.enterpriseFoundExplain != null ? data.crmCustomerEnterprise.enterpriseFoundExplain : ''),
              enterpriseScaleArray: (data.enterpriseScaleArray != null ? data.enterpriseScaleArray : ''),
              enterpriseTypeArray: (data.enterpriseTypeArray != null ? data.enterpriseTypeArray : ''),
              userType: (data.crmCustomerEnterprise.userType != null ? Number(data.crmCustomerEnterprise.userType) : 2),
              registrationType: (data.crmCustomerEnterprise.registrationType != null ? Number(data.crmCustomerEnterprise.registrationType) : 0)
            };
          }
        });
      }
    }
  };
</script>
<style lang="scss">
// .apply-loan-container {
//     background: #f7e8c4;
//   }
// .apply-loan-container2{
//   background: #c4f7cf;
// }
.step-form__step-num2{
      box-shadow: 0 0 46px rgba(253, 180, 69, 0.3);
    position: absolute;
    left: 33px;
    border-radius: 50%;
    width: 52px;
    height: 52px;
    line-height: 52px;
    color: #36A444;
    font-family: "Microsoft YaHei";
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    background-color: #fff;
}
.step-form__step-num{
      box-shadow: 0 0 46px rgba(253, 180, 69, 0.3);
    position: absolute;
    left: 33px;
    border-radius: 50%;
    width: 52px;
    height: 52px;
    line-height: 52px;
    color: #EB662B;
    font-family: "Microsoft YaHei";
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    background-color: #fff;
}
  .el-input.is-disabled .el-input__inner {
    background: #f7f7f7;
  }

  .step1-form .step-form__title {
    padding-bottom: 60px;
  }
  .step-form__form .el-form-item{
    margin-bottom: 5px !important;
  }
  .step-form__form .el-form-item__label {
    line-height: 40px;
  }
  .protocol_cont{
    margin-top: 35px;

    .el-form-item__error {
      margin-top: -12px;
    }
  }
  .step1__show-loan-contract {
    color: #EB662B;
  }
  .color2 {
    color: #36A444;
  }
 
  .step-form__btn-prev {
  background:#FF9F75;
  float: left;
  @include step-form__btn;
}
  .step-form__btn-next {
  background:#EB662B;
  float: right;
  @include step-form__btn;
}
 .step-form__btn-prev2 {
  background:#75BC42;
  float: left;
  @include step-form__btn;
}
  .step-form__btn-next2 {
  background:#36A444;
  float: right;
  @include step-form__btn;
}
.step-form__btn-container {
  @include clear;
}
</style>



// WEBPACK FOOTER //
// Step2.vue?19c2572e